import * as React from 'react';
import { RiskValueShape } from 'app/area/case/selectors';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { Badge, ButtonSecondary } from 'ui';
import { TooltipDirections } from 'ui/common/tooltip/tooltip';
import styles from './loss-potential-consequence-evaluation.scss';

interface Translations {
  textRiskArea: string;
  textRate: string;
}

export interface LossPotentialConsequenceEvaluationProps extends ConnectedComponentProps, RiskValueShape, Translations { }

export class LossPotentialConsequenceEvaluation extends React.PureComponent<LossPotentialConsequenceEvaluationProps, any> {

  private handleSelect = (e?: any) => {
    e && e.preventDefault();

    this.props.onSelectDocumentItem && this.props.onSelectDocumentItem();
  };

  public render() {
    const {
      textRate, riskArea, riskWeight, textRiskArea
    } = this.props;

    const { riskArea: riskAreaClass, rateButton } = styles;

    const hasRiskArea = !!riskArea && !!riskArea.value;

    const riskAreaNode = hasRiskArea && <div className={riskAreaClass}>
    <Badge
      title={textRiskArea}
      tooltip={riskArea.description}
      tooltipDirection={TooltipDirections.top}
      backgroundColor={riskArea.backgroundColor}
      foregroundColor={riskArea.foregroundColor}
      filled={true}
      text={riskWeight as any}
    /></div>;

    const rateLabel = !hasRiskArea && <ButtonSecondary onClick={this.handleSelect} style={rateButton}>{textRate}</ButtonSecondary>;

    return riskAreaNode || rateLabel;
  }
}
